function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M67 38.96a2 2 0 01-2 2h-.512c-.965 0-1.785.691-2.017 1.628a27.099 27.099 0 01-3.094 7.472c-.498.826-.408 1.895.274 2.577l.363.363a2 2 0 010 2.828l-4.186 4.185a2 2 0 01-2.828 0l-.363-.362c-.682-.682-1.75-.773-2.577-.275a27.11 27.11 0 01-7.472 3.095c-.937.233-1.628 1.052-1.628 2.017V65a2 2 0 01-2 2h-5.92a2 2 0 01-2-2v-.512c0-.965-.691-1.785-1.628-2.017a27.11 27.11 0 01-7.472-3.094c-.826-.499-1.895-.408-2.577.274l-.363.363a2 2 0 01-2.828 0l-4.185-4.186a2 2 0 010-2.828l.362-.362c.683-.683.773-1.752.275-2.579a27.082 27.082 0 01-3.095-7.47c-.232-.938-1.052-1.629-2.017-1.629H7a2 2 0 01-2-2v-5.92a2 2 0 012-2h.512c.965 0 1.785-.691 2.017-1.628a27.082 27.082 0 013.095-7.471c.498-.827.408-1.896-.275-2.578L11.987 19a2 2 0 010-2.828l4.185-4.186a2 2 0 012.828 0l.363.363c.683.682 1.75.773 2.577.274a27.109 27.109 0 017.472-3.094c.937-.232 1.628-1.052 1.628-2.017V7a2 2 0 012-2h5.92a2 2 0 012 2v.512c0 .965.691 1.785 1.628 2.017a27.109 27.109 0 017.472 3.095c.826.498 1.895.407 2.577-.275l.363-.363a2 2 0 012.828 0l4.185 4.186a2 2 0 010 2.828l-.362.363c-.682.682-.772 1.75-.274 2.577a27.099 27.099 0 013.094 7.472c.233.937 1.052 1.628 2.017 1.628H65a2 2 0 012 2v5.92z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.047 2.968c.81-.5 1.05-.638 1.898-1.078M1.296 17.783a36.841 36.841 0 0110.79-12.822M56.08 69.334c-.82.48-1.22.694-2.079 1.111M70.266 54.855a36.86 36.86 0 01-11.18 12.578",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.147 31a14.954 14.954 0 00-1.786-3.5C45.656 23.574 41.129 21 36 21c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 6.531 0 12.087-4.174 14.147-10m.82-6a15.193 15.193 0 010 2M16.683 27.762c2.476-5.804 7.255-9.918 12.817-11.731m21.971 34.178A21.04 21.04 0 0142 56.125m13.824-13.192a21.288 21.288 0 01-1.099 2.575M15.411 31.843a20.847 20.847 0 00-.373 5.488",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 37a4 4 0 100-8 4 4 0 000 8zM24 46c2.965-1.973 7-3 11.98-3 4.977 0 9.055 1.009 12.02 2.982",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/in-progress.svg";
export { SvgInProgress as ReactComponent };